export function isSuccessfulResponse(status: number): boolean {
    return status >= 200 && status < 300;
}
